import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PartnerCallersQueryVariables } from '@/gql/graphql';

export const fetchPartnerCallers = async (variables: PartnerCallersQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables,
    query: graphql(`
      query PartnerCallers($pagination: PaginationInputType, $partnerCode: String, $phoneNumber: String) {
        partnerCallers(pagination: $pagination, partnerCode: $partnerCode, phoneNumber: $phoneNumber) {
          count
          rows {
            callerId
            partnerId
            credits
            rides
            partnerCode
            partnerName
            callerPhoneNumber
            callerFirstName
            callerLastName
          }
        }
      }
    `),
  });

  return response.data.partnerCallers;
};
